var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M8.59 16.58L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.42z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }